import { addNewRtoError, addNewRtoSuccess } from "./Action";
import { ADD_NEW_RTO } from "./Constants";
import { addNewRtoAPI } from "./api";
import { call, put, takeEvery, takeLatest, delay } from "redux-saga/effects"
function* addNewRtoAsync(payload) {
    try {
        const response = yield call(addNewRtoAPI, payload.payload)
        if (response && response.data.status === 1) {
            yield put(addNewRtoSuccess(response.data.message || "New RTO Added Succefully!..."))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(addNewRtoError(error.response.data.error || "Unable to Add RTO"))
    }
}

function* ManageRtoSaga() {

    yield takeEvery(ADD_NEW_RTO, addNewRtoAsync)
  
}

export default ManageRtoSaga;
